import { CHESS_CONFIG } from './games.js';
export const TIEBREAK_CRITERIA = CHESS_CONFIG.tiebreakCriteria;
export const DEFAULT_TIEBREAK_CRITERIA = CHESS_CONFIG.tiebreakCriteria.slice(0, 5);
export const REQUIRED_PROFILE_FIELD_LABELS = {
    city: 'City',
    country: 'Country',
    bio: 'Bio',
    avatar: 'Avatar',
    chess_rating: 'Chess rating',
    chess_fide_id: 'FIDE ID',
    chess_club: 'Chess club',
    backgammon_club: 'Backgammon club',
    bmab_title: 'BMAB title',
};
const GENERAL_REQUIRED_PROFILE_FIELDS = [
    'city',
    'country',
    'bio',
    'avatar',
];
const CHESS_REQUIRED_PROFILE_FIELDS = [
    'chess_rating',
    'chess_fide_id',
    'chess_club',
];
const BACKGAMMON_REQUIRED_PROFILE_FIELDS = [
    'backgammon_club',
    'bmab_title',
];
/** The full set of fields a tournament of the given game can require. */
export function allowedRequiredProfileFields(game) {
    if (game === 'chess') {
        return [...GENERAL_REQUIRED_PROFILE_FIELDS, ...CHESS_REQUIRED_PROFILE_FIELDS];
    }
    if (game === 'backgammon') {
        return [...GENERAL_REQUIRED_PROFILE_FIELDS, ...BACKGAMMON_REQUIRED_PROFILE_FIELDS];
    }
    return [...GENERAL_REQUIRED_PROFILE_FIELDS];
}
export function isRequiredProfileField(value) {
    return (typeof value === 'string' &&
        value in REQUIRED_PROFILE_FIELD_LABELS);
}
/** Story 100 — how a self-registered player's spot gets secured. */
export const SPOT_CONFIRMATION_MODES = ['manual', 'auto'];
/** Story 105 — KO qualifier: complete when the field is reduced to this many
 *  players (or fewer). 1 = play until a single winner (default). 3ko/5ko only. */
export const KO_FINISH_TOP_OPTIONS = [1, 2, 4, 8, 16, 32];
export function effectiveMatchStatus(p) {
    if (p.resultStatus === 'confirmed')
        return 'confirmed';
    if (p.resultStatus === 'pending')
        return 'pending';
    if (p.startedAt)
        return 'in_progress';
    return 'none';
}
//# sourceMappingURL=tournament.js.map